import { markRaw, watch } from "vue"
import { toast } from "vue-sonner"
import UploadTray from "@/components/files/UploadTray.vue"
import { useUploadsStore } from "@/stores/uploads"

/** The one toast the upload queue lives in. */
const TOAST_ID = "uploads"

/**
 * Shows the upload queue (UploadTray) as a persistent toast while it holds
 * anything, and dismisses it once cleared. Call once, from App.
 *
 * Re-asserted whenever a file joins, leaves or changes status (the same id
 * updates the toast in place), so a toast the toaster dropped comes back with
 * the next change rather than leaving uploads with no tray.
 */
export function useUploadToast() {
  const store = useUploadsStore()
  watch(
    () => store.uploads.map((u) => `${u.id}:${u.status}`).join(","),
    (signature) => {
      if (!signature) {
        toast.dismiss(TOAST_ID)
        return
      }
      toast.custom(markRaw(UploadTray), {
        id: TOAST_ID,
        duration: Infinity,
        dismissible: false,
        unstyled: true,
      })
    },
    { immediate: true }
  )
}
